import { isInWechat, isIOS } from '@eaphone/env';

if (isIOS && isInWechat) {
  // iOS 返回问题
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      window.location.reload();
    }
  });
}
